<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadCustomFields(1, null, true)">

      <template slot="actions">
        <vx-input-group>
          <vs-input :placeholder="$t('custom_field_name')" v-model="customFieldFormData.name" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationMemberCustomFieldButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addCustomField">{{ $t('add_custom_field') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('custom_field_name')" v-model="customFieldSearchParams.name" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="statusOptions" :reduce="label => label.value" :placeholder="$t('status')" v-model="customFieldSearchParams.isActive"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadCustomFields(1, null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="memberCustomFieldDataContainer" :title="$t('custom_fields')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-member-custom-field-list
        :customFields="customFields"
        @customClickStatus="status"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-member-custom-field-list>

      <template slot="footer">
        <paginate
          :total="customFieldPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadCustomFields"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import MemberCustomField from '@/models/MemberCustomField'
import SharedUserConfigurationMemberCustomFieldList from '@/views/Shared/Configuration/Member/CustomFields/List'
import Paginate from '@/mixins/paginate'
import { statusOptions } from '@/config/options'

export default {
  name: 'User.Configuration.Member.CustomFields',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationMemberCustomFieldList
  },
  data () {
    return {
      customFieldsEdit: {},
      customFields: {},
      customFieldPages: 1,
      customFieldFormData: {
        name: '',
        is_active: '',
        id: ''
      },
      customFieldFormErrors: {},
      itemPerPage: null,
      customFieldSearchParams: {
        name: typeof this.$route.query.name !== 'undefined' ? this.$route.query.name : '',
        isActive: typeof this.$route.query.isActive !== 'undefined' ? this.$route.query.isActive : ''
      },
      statusOptions
    }
  },
  mounted () {
    this.loadCustomFields(this.initialPage, null,  false, true)
  },
  methods: {
    async loadCustomFields (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#memberCustomFieldDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({query: {...this.groupSearchParams, page, itemPerPage}})
      }
      const response = await MemberCustomField.all({ ...this.customFieldSearchParams, page, itemPerPage })
      this.customFields = response.data.data.customFields
      this.customFieldPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }

      this.$vs.loading.close('#memberCustomFieldDataContainer > .con-vs-loading')
    },
    async addCustomField (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationMemberCustomFieldButton', scale: 0.45})
      if (this.customFieldFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_member_custom_field_error_message'),
          confirmButton: this.$t('confirm')
        })

        this.$store.dispatch('setIsFormInProgress', false)

      } else {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          await MemberCustomField.save(this.customFieldFormData)
          this.$store.dispatch('setIsFormInProgress', false)
          this.loadCustomFields(1, this.itemPerPage)
          this.customFieldFormData = {
            name: '',
            is_active: '',
            id: ''
          }
        }
        this.customFieldFormErrors = {}
      }
      this.$vs.loading.close('#addConfigurationMemberCustomFieldButton > .con-vs-loading')
    },
    async status (key) {
      try {
        if (this.customFields[key].is_active === 1) {
          this.customFields[key].is_active = 0
        } else {
          this.customFields[key].is_active = 1
        }
        await MemberCustomField.update(this.customFields[key])
        this.customFields[key].customFieldFormErrors = {}
      } catch (e) {
        this.customFields[key].customFieldFormErrors = e.response.data.errors
      }
    },
    async edit (key) {
      this.customFields[key].edit = true
      const editElem = this.customFields[key]
      const editObj = {
        name: editElem.name
      }
      this.customFieldsEdit[key] = editObj
    },
    async cancel (key) {
      this.customFields[key].name = this.customFieldsEdit[key].name
      this.customFields[key].edit = false
      this.customFields[key].customFieldFormErrors = {}
      delete this.customFieldsEdit[key]
    },
    async save (key, id) {
      try {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('custom_field_update_confirmation_title'),
          text: this.$t('custom_field_update_confirmation_text'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })
        if (confirm.value) {
          this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationMemberCustomFieldButton${ id }`, scale: 0.45})
          await MemberCustomField.update(this.customFields[key])
          this.customFields[key].edit = false
          this.customFields[key].customFieldFormErrors = {}
          this.$vs.loading.close(`#updateConfigurationMemberCustomFieldButton${ id } > .con-vs-loading`)
        }
      } catch (e) {
        this.customFields[key].customFieldFormErrors = e.response.data.errors
        this.$vs.loading.close(`#updateConfigurationMemberCustomFieldButton${ id } > .con-vs-loading`)
      }
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await MemberCustomField.destroy(id)
        this.loadCustomFields(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationMemberCustomFieldButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
